"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AGEquipmentType = exports.AGPropertyIdentity = exports.AGPropertyType = exports.CommercialBusinessOwnershipType = exports.CommercialTrends = exports.CommercialBusinessType = exports.CommercialEntityType = exports.CommercialLoanHolder = exports.EquipmentOrInventory = exports.CommercialLoanTiming = exports.BridgeOrCredit = void 0;
var BridgeOrCredit;
(function (BridgeOrCredit) {
    BridgeOrCredit["BRIDGE"] = "Bridge Loan";
    BridgeOrCredit["CREDIT"] = "Line of Credit";
})(BridgeOrCredit = exports.BridgeOrCredit || (exports.BridgeOrCredit = {}));
var CommercialLoanTiming;
(function (CommercialLoanTiming) {
    CommercialLoanTiming["WITHIN_1_WEEK"] = "Within 1 Week";
    CommercialLoanTiming["WITHIN_1_MONTH"] = "Within 1 Month";
    CommercialLoanTiming["ONE_THROUGH_THREE"] = "1-3 Months";
    CommercialLoanTiming["THREE_PLUS"] = "3+ Months";
})(CommercialLoanTiming = exports.CommercialLoanTiming || (exports.CommercialLoanTiming = {}));
var EquipmentOrInventory;
(function (EquipmentOrInventory) {
    EquipmentOrInventory["EQUIPMENT"] = "Equipment";
    EquipmentOrInventory["INVENTORY"] = "Inventory";
})(EquipmentOrInventory = exports.EquipmentOrInventory || (exports.EquipmentOrInventory = {}));
var CommercialLoanHolder;
(function (CommercialLoanHolder) {
    CommercialLoanHolder["BUSINESS"] = "Business";
    CommercialLoanHolder["INDIVIDUAL"] = "Individual";
})(CommercialLoanHolder = exports.CommercialLoanHolder || (exports.CommercialLoanHolder = {}));
var CommercialEntityType;
(function (CommercialEntityType) {
    CommercialEntityType["CORPORATION"] = "Corporation";
    CommercialEntityType["LLC"] = "LLC";
    CommercialEntityType["SOLE"] = "SoleProprietorship";
    CommercialEntityType["S_CORP"] = "S-Corp";
    CommercialEntityType["PARTNERSHIP"] = "Partnership";
})(CommercialEntityType = exports.CommercialEntityType || (exports.CommercialEntityType = {}));
var CommercialBusinessType;
(function (CommercialBusinessType) {
    CommercialBusinessType["CONSTRUCTION"] = "Construction";
    CommercialBusinessType["MANUFACTURING"] = "Manufacturing";
    CommercialBusinessType["REAL_ESTATE"] = "Real Estate";
    CommercialBusinessType["RETAIL"] = "Retail";
    CommercialBusinessType["SERVICE"] = "Service";
    CommercialBusinessType["WHOLESALE"] = "Wholesale";
    CommercialBusinessType["OTHER"] = "Other";
})(CommercialBusinessType = exports.CommercialBusinessType || (exports.CommercialBusinessType = {}));
var CommercialTrends;
(function (CommercialTrends) {
    CommercialTrends["INCREASING"] = "Increasing";
    CommercialTrends["DECREASING"] = "Decreasing";
    CommercialTrends["STABLE"] = "Stable";
})(CommercialTrends = exports.CommercialTrends || (exports.CommercialTrends = {}));
var CommercialBusinessOwnershipType;
(function (CommercialBusinessOwnershipType) {
    CommercialBusinessOwnershipType["MINORITY"] = "Minority";
    CommercialBusinessOwnershipType["NA"] = "N/A";
    CommercialBusinessOwnershipType["WOMEN"] = "Women";
    CommercialBusinessOwnershipType["LGBTQI"] = "LGBTQI+";
})(CommercialBusinessOwnershipType = exports.CommercialBusinessOwnershipType || (exports.CommercialBusinessOwnershipType = {}));
var AGPropertyType;
(function (AGPropertyType) {
    AGPropertyType["ACREAGE"] = "Acreage";
    AGPropertyType["BARN"] = "Barn";
    AGPropertyType["COOP"] = "Coop";
    AGPropertyType["COWSHED"] = "Cowshed";
    AGPropertyType["FARMHOUSE"] = "Farmhouse";
    AGPropertyType["GREENHOUSE"] = "Greenhouse";
    AGPropertyType["OTHER"] = "Other";
    AGPropertyType["SILO"] = "Silo";
    AGPropertyType["STABLE"] = "Stable";
    AGPropertyType["STORAGE"] = "Storage";
    AGPropertyType["STY"] = "Sty";
})(AGPropertyType = exports.AGPropertyType || (exports.AGPropertyType = {}));
var AGPropertyIdentity;
(function (AGPropertyIdentity) {
    AGPropertyIdentity["ADDRESS"] = "Address";
    AGPropertyIdentity["LEGAL_DESCRIPTION"] = "Legal Description";
})(AGPropertyIdentity = exports.AGPropertyIdentity || (exports.AGPropertyIdentity = {}));
var AGEquipmentType;
(function (AGEquipmentType) {
    AGEquipmentType["COMBINE"] = "Combine";
    AGEquipmentType["TRACTOR"] = "Tractor";
    AGEquipmentType["HARROW"] = "Harrow";
    AGEquipmentType["HARVESTER"] = "Harvester";
    AGEquipmentType["OTHER"] = "Other";
    AGEquipmentType["PLOW"] = "Plow";
    AGEquipmentType["SEEDER"] = "Seeder";
    AGEquipmentType["SPRAYER"] = "Sprayer";
    AGEquipmentType["SPREADER"] = "Spreader";
})(AGEquipmentType = exports.AGEquipmentType || (exports.AGEquipmentType = {}));
